import * as tslib_1 from "tslib";
import { Component, Vue, Ref } from 'vue-property-decorator';
import QrCode from 'qrcode';
import { UserModule } from "@/store/modules/user";
import { uploadAudioCover } from "@/api/material";
import { getImageList, getLiveDetail, getLiveLink, getLiveList, getSaleLinks, getVideoList, requestLiveSave, requestLiveStatusChange, requestSaleLinkGenerate } from '@/api/live';
import { Throttle } from '@/decorators';
let LiveList = class LiveList extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.lives = [];
        this.searcher = {
            title: '',
            status: '',
            _title: '',
            _status: ''
        };
        this.paginator = {
            pageNo: 1,
            pageSize: 20,
            total: 0,
        };
        this.liveEditor = {
            visible: false,
            loading: false,
            content: {
                id: '',
                title: '',
                liveTime: null,
                replayEndTime: null,
                liveVideoId: '',
                videoName: '',
                videoId: '',
                mode: 1,
                status: 1,
                coverUrl: '',
                picList: [],
                timingReviewList: []
            }
        };
        this.isCoverUploading = false;
        this.videoSelector = {
            visible: false,
            loading: false,
            list: [],
            searcher: {
                title: '',
                _title: ''
            },
            paginator: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
            content: {
                id: '',
                detail: null
            }
        };
        this.qrcodeModal = {
            visible: false,
            loading: false,
            content: {
                url: '',
                qrcode: ''
            }
        };
        this.imageSelector = {
            visible: false,
            loading: false,
            list: [],
            searcher: {
                title: '',
                _title: ''
            },
            paginator: {
                pageNo: 1,
                pageSize: 5,
                total: 0,
            },
            selected: [],
            selectedImageIds: []
        };
        this.commentEditor = {
            visible: false,
            content: {
                timeStr: null,
                content: '',
            },
            targetIndex: -1
        };
        this.saleLinksModal = {
            visible: false,
            loading: false,
            searcher: {
                id: '',
                salename: '',
                _salename: ''
            },
            paginator: {
                pageNo: 1,
                pageSize: 20,
                total: 0,
            },
            list: []
        };
    }
    created() {
        this.loadLiveList();
    }
    async loadLiveList() {
        this.loading = true;
        const params = {
            title: this.searcher._title,
            status: this.searcher._status,
            pageNo: this.paginator.pageNo,
            pageSize: this.paginator.pageSize
        };
        try {
            const res = await getLiveList(params);
            const data = res.data.data;
            this.lives = data.list || [];
            this.paginator.total = Number(data.total);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.loading = false;
        }
    }
    handleLiveSearch() {
        this.searcher._title = this.searcher.title;
        this.searcher._status = this.searcher.status;
        this.paginator.pageNo = 1;
        this.loadLiveList();
    }
    handlePageChange(pageNo) {
        this.paginator.pageNo = pageNo;
        this.loadLiveList();
    }
    async handleStatusChange(status, row) {
        let _status = status === 1 ? 0 : 1; // prev status
        row.status = _status;
        try {
            await this.$confirm(`是否确认${status === 1 ? '上线' : '下线'}该直播`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
        }
        catch (error) {
            return;
        }
        try {
            await requestLiveStatusChange(row.id, status);
            // row.status = status;
            this.loadLiveList();
            this.$message.success(`${status === 1 ? '上线' : '下线'}成功`);
        }
        catch (error) {
            console.error(error);
        }
    }
    async loadLiveDetail(id, copy = false) {
        this.liveEditor.loading = true;
        try {
            const res = await getLiveDetail(id);
            const data = res.data.data;
            data.picList = data.picList || [];
            data.timingReviewList = data.timingReviewList || [];
            data.id = !copy ? data.id : void 0;
            this.liveEditor.content = data;
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.liveEditor.loading = false;
        }
    }
    showLiveEditor() {
        this.liveEditor = {
            visible: true,
            loading: false,
            content: {
                id: '',
                title: '',
                liveTime: null,
                replayEndTime: null,
                liveVideoId: '',
                videoName: '',
                mode: 1,
                coverUrl: '',
                picList: [],
                timingReviewList: []
            }
        };
    }
    closeLiveEditor() {
        this.liveEditor.visible = false;
    }
    handleLiveAddClick() {
        this.showLiveEditor();
    }
    handleLiveEditClick(id) {
        this.showLiveEditor();
        this.loadLiveDetail(id);
    }
    handleLiveCopyClick(id) {
        this.showLiveEditor();
        this.loadLiveDetail(id, true);
    }
    showVideoSelector() {
        this.videoSelector = {
            visible: true,
            loading: false,
            list: [],
            searcher: {
                title: '',
                _title: ''
            },
            paginator: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
            content: {
                id: '',
                detail: null
            }
        };
        this.loadVideoList();
    }
    closeVideoSelector() {
        this.videoSelector.visible = false;
    }
    async loadVideoList() {
        this.videoSelector.loading = true;
        try {
            const res = await getVideoList({
                name: this.videoSelector.searcher._title,
                pageNo: this.videoSelector.paginator.pageNo,
                pageSize: this.videoSelector.paginator.pageSize
            });
            const data = res.data.data;
            this.videoSelector.list = data.list || [];
            this.videoSelector.paginator.total = Number(data.total);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.videoSelector.loading = false;
        }
    }
    handleVideoPageChange(page) {
        this.videoSelector.paginator.pageNo = page;
        this.loadVideoList();
    }
    handleVideoSearch() {
        this.videoSelector.searcher._title = this.videoSelector.searcher.title;
        this.videoSelector.paginator.pageNo = 1;
        this.loadVideoList();
    }
    handleVideoSelect(video) {
        this.videoSelector.content.detail = video;
    }
    handleVideoClear() {
        this.liveEditor.content.liveVideoId = '';
        this.liveEditor.content.videoName = '';
        this.liveEditFormRef.validateField('liveVideoId');
    }
    handleVideoConfirm() {
        const video = this.videoSelector.content.detail;
        this.liveEditor.content.liveVideoId = video.id;
        this.liveEditor.content.videoName = video.videoName;
        this.closeVideoSelector();
        this.liveEditFormRef.validateField('liveVideoId');
    }
    handleCoverSelect(file) {
        // const isLt5M: boolean = file.size / 1024 / 1024 < 5;
        // if (!isLt5M) {
        //     this.$message.error("封面图片大小不能超过 5MB!");
        //     return false;
        // }
        const isJPG = file.type === "image/jpg" || file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        if (!(isJPG || isPNG)) {
            this.$message.error("封面图片只能是JPG/PNG格式!");
            return false;
        }
        return true;
    }
    async handleCoverUpload(data) {
        this.isCoverUploading = true;
        const file = data.file;
        try {
            const res = await uploadAudioCover(file, {
                token: UserModule.token,
                ssoId: UserModule.ssoId,
            });
            // 防止奇奇怪怪的人卡bug, 重置状态后再取消禁用上传
            this.$nextTick(() => {
                this.isCoverUploading = false;
            });
            if (res.data.status !== 200) {
                this.coverUploaderRef.clearFiles();
            }
            else {
                this.liveEditor.content.coverUrl = res.data.data;
                this.liveEditFormRef.validateField('coverUrl');
            }
        }
        catch {
            this.isCoverUploading = false;
        }
    }
    resetLiveList() {
        this.searcher = {
            title: '',
            status: '',
            _title: '',
            _status: ''
        };
        this.loadLiveList();
    }
    async handleLiveSave() {
        try {
            await this.liveEditFormRef.validate();
        }
        catch (error) {
            return;
        }
        const live = this.liveEditor.content;
        const data = {
            id: live.id ? live.id : void 0,
            title: live.title,
            liveTime: live.liveTime,
            replayEndTime: live.replayEndTime,
            liveVideoId: live.liveVideoId,
            mode: live.mode,
            coverUrl: live.coverUrl,
            livePicIdList: live.picList.map(i => i.id),
            reviewList: live.timingReviewList
        };
        this.liveEditor.loading = true;
        try {
            await requestLiveSave(data);
            this.$message.success('保存成功');
            this.resetLiveList();
            this.closeLiveEditor();
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.liveEditor.loading = false;
        }
    }
    showQrcodeModal(id) {
        this.qrcodeModal = {
            visible: true,
            loading: false,
            content: {
                url: '',
                qrcode: ''
            }
        };
        this.loadLiveLink(id);
    }
    closeQrcodeModal() {
        this.qrcodeModal.visible = false;
    }
    async loadLiveLink(id) {
        this.qrcodeModal.loading = true;
        try {
            const res = await getLiveLink(id);
            const url = res.data.data;
            this.qrcodeModal.content.url = url;
            QrCode.toDataURL(url, {
                margin: 1,
                width: 150,
            }, (error, qrcode) => {
                if (error) {
                    console.error(error);
                    return this.$message.error('二维码生成失败');
                }
                this.qrcodeModal.content.qrcode = qrcode;
                this.qrcodeModal.loading = false;
            });
        }
        catch (error) {
            console.error(error);
        }
    }
    onLiveLinkCopied() {
        this.$message.success('复制成功');
    }
    base64ToBlob(base64) {
        var parts = base64.split(";base64,");
        var contentType = parts[0].split(":")[1];
        var raw = window.atob(parts[1]);
        var rawLength = raw.length;
        var uint8Array = new Uint8Array(rawLength);
        for (var i = 0; i < rawLength; i++) {
            uint8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uint8Array], { type: contentType });
    }
    handleQrcodeDownload(qrcode) {
        let base64 = qrcode;
        var date = new Date();
        if (!base64) {
            return;
        }
        var aLink = document.createElement("a"); // 创建一个a标签
        var blob = this.base64ToBlob(base64);
        var event = document.createEvent("HTMLEvents");
        event.initEvent("click", true, true);
        aLink.download = date.getTime() + ''; // 使用时间戳给文件命名
        aLink.href = URL.createObjectURL(blob);
        aLink.click();
    }
    showImageSelector() {
        this.imageSelector = {
            visible: true,
            loading: false,
            list: [],
            searcher: {
                title: '',
                _title: ''
            },
            paginator: {
                pageNo: 1,
                pageSize: 5,
                total: 0,
            },
            selected: [],
            selectedImageIds: []
        };
        this.loadImageList();
    }
    closeImageSelector() {
        this.imageSelector.visible = false;
    }
    async loadImageList() {
        this.imageSelector.loading = true;
        try {
            const res = await getImageList({
                name: this.imageSelector.searcher._title,
                pageNo: this.imageSelector.paginator.pageNo,
                pageSize: this.imageSelector.paginator.pageSize
            });
            const data = res.data.data;
            this.imageSelector.list = data.list || [];
            this.imageSelector.paginator.total = Number(data.total);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.imageSelector.loading = false;
        }
    }
    handleImagePageChange(page) {
        this.imageSelector.paginator.pageNo = page;
        this.loadImageList();
    }
    handleImageSearch() {
        this.imageSelector.searcher._title = this.imageSelector.searcher.title;
        this.imageSelector.paginator.pageNo = 1;
        this.loadImageList();
    }
    handleImageSelect(image, state) {
        const selectedImage = this.imageSelector.selected;
        if (state) {
            selectedImage.push(image);
        }
        else {
            const index = selectedImage.findIndex(_image => _image.id === image.id);
            selectedImage.splice(index, 1);
        }
    }
    handleImageConfirm() {
        const selectedImage = this.imageSelector.selected;
        this.liveEditor.content.picList.push(...selectedImage);
        this.closeImageSelector();
    }
    handleImageRemove(index) {
        this.liveEditor.content.picList.splice(index, 1);
    }
    showCommentEditor(index = -1) {
        this.commentEditor = {
            visible: true,
            content: index >= 0 ? this.liveEditor.content.timingReviewList[index] : {
                timeStr: null,
                content: '',
            },
            targetIndex: index
        };
    }
    closeCommentEditor() {
        this.commentEditor.visible = false;
    }
    async handleCommentSave() {
        try {
            await this.commentEditorRef.validate();
        }
        catch (error) {
            console.error(error);
            return;
        }
        const index = this.commentEditor.targetIndex;
        const comment = this.commentEditor.content;
        if (index === -1) {
            this.liveEditor.content.timingReviewList.push(comment);
        }
        else {
            this.liveEditor.content.timingReviewList[index] = comment;
        }
        this.closeCommentEditor();
    }
    handleCommentRemove(index) {
        this.liveEditor.content.timingReviewList.splice(index, 1);
    }
    async loadSaleLinks() {
        this.saleLinksModal.loading = true;
        const { searcher, paginator } = this.saleLinksModal;
        try {
            const res = await getSaleLinks({
                id: searcher.id,
                salesmanNickname: searcher._salename,
                pageNo: paginator.pageNo,
                pageSize: paginator.pageSize
            });
            const data = res.data.data;
            paginator.total = Number(data.total);
            this.saleLinksModal.list = data.list.map(item => {
                const link = {
                    id: item.id,
                    url: item.linkUrl,
                    salename: item.salesmanNickname,
                    qrcode: ''
                };
                QrCode.toDataURL(item.linkUrl, {
                    margin: 1,
                    width: 600,
                }, (error, qrcode) => {
                    if (error)
                        return console.error(error);
                    link.qrcode = qrcode;
                });
                return link;
            });
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.saleLinksModal.loading = false;
        }
    }
    showSaleLinksModal(id) {
        this.saleLinksModal = {
            visible: true,
            loading: false,
            searcher: {
                id,
                salename: '',
                _salename: ''
            },
            paginator: {
                pageNo: 1,
                pageSize: 20,
                total: 0,
            },
            list: []
        };
        this.loadSaleLinks();
    }
    closeSaleLinksModal() {
        this.saleLinksModal.visible = false;
    }
    handleSaleLinkSearch() {
        this.saleLinksModal.searcher._salename = this.saleLinksModal.searcher.salename;
        this.saleLinksModal.paginator.pageNo = 1;
        this.loadSaleLinks();
    }
    handleSaleLinkPageChange(pageNo) {
        this.saleLinksModal.paginator.pageNo = pageNo;
        this.loadSaleLinks();
    }
    async handleSaleLinkAdd() {
        let salename = '';
        try {
            const res = await this.$prompt('请输入销售名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '请输入销售名称',
                inputPattern: /^\S+$/,
                inputErrorMessage: '请输入销售名称'
            });
            salename = res.value;
        }
        catch (error) {
            return;
        }
        try {
            await requestSaleLinkGenerate({
                id: this.saleLinksModal.searcher.id,
                salesmanNickname: salename
            });
            this.$message.success('创建成功');
            this.loadSaleLinks();
        }
        catch (error) {
        }
    }
};
tslib_1.__decorate([
    Ref()
], LiveList.prototype, "coverUploaderRef", void 0);
tslib_1.__decorate([
    Ref()
], LiveList.prototype, "liveEditFormRef", void 0);
tslib_1.__decorate([
    Ref()
], LiveList.prototype, "commentEditorRef", void 0);
tslib_1.__decorate([
    Throttle(500)
], LiveList.prototype, "handleLiveSave", null);
LiveList = tslib_1.__decorate([
    Component({
        name: 'LiveList',
        filters: {
            formatLiveMode(mode) {
                return [, '横屏', '竖屏'][mode] || '';
            },
            formatImageType(type) {
                return [, '讲解图片', '商品图片'][type] || '';
            }
        }
    })
], LiveList);
export default LiveList;
